import { useEffect, useState } from 'react'
import { Loader } from '@nv/basic-components'
import { VoterAuthService } from '@nv/services'
import { useVoterUserContext } from 'libs/contexts/src/lib/VoterUserContext'
import { useCheckVotingOpenStateChange } from 'libs/hooks/src/lib/useCheckVotingOpenStateChange'
import { useHandleLogout } from 'libs/hooks/src/lib/useHandleLogout'
import { beforeUnload } from 'libs/utils/src/lib/BeforeUnload'
import { useTranslation } from 'react-i18next'

export function VoterEligibility() {
  const { t, i18n } = useTranslation()
  const [agreed, setAgreed] = useState(false)
  const currentLanguage = i18n.language
  const [event, setEvent] = useState(null as any)
  const [loading, setLoading] = useState(true)
  const VoterUser = useVoterUserContext().voterUser
  const handleLogout = useHandleLogout()

  const fetchEvents = async () => {
    const updatedEvents = await VoterAuthService.getUserEvents()
    if (updatedEvents) {
      const activeEvents = updatedEvents.active || []
      if (activeEvents.length) {
        const activeEvent = activeEvents[0]
        setEvent(activeEvent)
        const hasVoted = VoterUser.votedInEvents?.includes(activeEvent?.tiviId)
        if (hasVoted) handleLogout()
        if (activeEvent) {
          window.location.href = `${activeEvent.eventLink}?locale=${currentLanguage || 'en'}`
        }
      }
    }
    setLoading(false)
  }

  useEffect(() => {
    window.removeEventListener('beforeunload', beforeUnload)
    fetchEvents()
  }, [])

  const { votingOpen } = useCheckVotingOpenStateChange({
    event,
    closeDate: event?.closeDate,
  })

  const handleNext = () => {
    if (event && votingOpen) {
      VoterAuthService.updateUserTiviAuthenticated({
        tiviId: event.tiviId,
      })
      window.location.href = `${event.eventLink}?locale=${currentLanguage || 'en'}`
    }
  }

  return <Loader />

  // return (
  //   <>
  //     <Announce title={t('eligibility.title')} setPageName={true} />

  //     <div className={styles['container']}>
  //       <div className={styles['card']}>
  //         <h1 className={styles['title']}>{t('eligibility.title')}</h1>

  //         <p className={styles['important']}>
  //           <strong>{t('eligibility.importantLabel')} </strong>
  //           {t('eligibility.importantText')}
  //         </p>

  //         <p>{t('eligibility.declareIntro')}</p>

  //         <ul className={styles['list']}>
  //           <li>{t('eligibility.declare1')}</li>
  //           <li>{t('eligibility.declare2')}</li>
  //           <li>{t('eligibility.declare3')}</li>
  //           <li>{t('eligibility.declare4')}</li>
  //           <li>{t('eligibility.declare5')}</li>
  //         </ul>

  //         <p>{t('eligibility.statementParagraph')}</p>

  //         <ul className={styles['list']}>
  //           <li>{t('eligibility.illegal1')}</li>
  //           <li>{t('eligibility.illegal2')}</li>
  //           <li>{t('eligibility.illegal3')}</li>
  //           <li>{t('eligibility.illegal4')}</li>
  //           <li>{t('eligibility.illegal5')}</li>
  //           <li>{t('eligibility.illegal6')}</li>
  //           <li>{t('eligibility.illegal7')}</li>
  //           <li>{t('eligibility.illegal8')}</li>
  //           <li>{t('eligibility.illegal9')}</li>
  //           <li>{t('eligibility.illegal10')}</li>
  //           <li>{t('eligibility.illegal11')}</li>
  //         </ul>

  //         <p>{t('eligibility.penaltyParagraph')}</p>

  //         <div className={styles['checkbox']}>
  //           <CheckBox checked={agreed} onChange={setAgreed} label={t('eligibility.agreeLabel')} isRequired={true} square={true} />
  //         </div>
  //       </div>

  //       <div className={styles['actions']}>
  //         <NVButton text={t('buttons.next')} variant='primary' disabled={!agreed} onClick={handleNext} />
  //       </div>
  //     </div>
  //   </>
  // )
}
